import api from '../../utils/api';

export const fetchCart = async () => {
  const response = await api.get('/cart');
  return response.data.data;
};

export const addToCart = async (itemData) => {
  const response = await api.post('/cart/add', itemData);
  return response.data.data;
};

export const updateCartItem = async (itemId, data) => {
  const response = await api.put('/cart/update', { itemId, ...data });
  return response.data.data;
};

export const removeCartItem = async (itemId) => {
  const response = await api.delete(`/cart/remove/${itemId}`);
  return response.data.data;
};

export const clearCart = async () => {
  const response = await api.delete('/cart/clear');
  return response.data.data;
};
